import * as types from './mutation_types';

let actions = {
    show_alert({commit}, data){
        commit(types.SET_ALERT_SHOW);
        commit(types.SET_ALERT_DATA, data);
    },
    show_confirm({commit}, data){
        commit(types.SET_CONFIRM_SHOW);
        commit(types.SET_CONFIRM_DATA, data);
    },
    show_titleConfirm({commit}, data){
        commit(types.SET_TITLE_CONFIRM_SHOW);
        commit(types.SET_TITLE_CONFIRM_DATA, data);
    }
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/actions.js